export default __webpack_public_path__ + "static/media/chevrons-left.13ee1704.svg";